module.exports = __webpack_public_path__ + "img/404.50b1e57.avif";